<template>
  <div class="container">
    <b-alert
      show
      variant="info"
    >Verifying token...</b-alert>
  </div>
</template>

<script>
export default {
  async created() {
    const { token } = this.$route.query;

    if (!token) {
      this.$router.push({ name: "Login" });
      return;
    }

    await this.$store.dispatch("user/verify", token);

    this.$router.push({ name: "Home" });
  }
};
</script>
